import { useState } from 'react'

const CHARACTER_COLORS = { explorer: '#FF8C42', thinker: '#4ECDC4', buddy: '#45B7D1' }

const layerStyle = { position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'contain' }

const ImgLayer = ({ src, fallbackColor, fallbackEmoji, style: extraStyle }) => {
  const [err, setErr] = useState(false)
  if (!src) return null
  if (err) return (
    <div style={{ ...layerStyle, ...extraStyle, background: fallbackColor || 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 16 }}>
      {fallbackEmoji ? <img src={fallbackEmoji} alt="" style={{ width: '60%', height: '60%', objectFit: 'contain' }} /> : null}
    </div>
  )
  return <img src={src} alt="" onError={() => setErr(true)} style={{ ...layerStyle, ...extraStyle }} />
}

const AvatarPreview = ({ previewAvatar, onReset, onSave, saving }) => {
  const { character, skin, hat, handItem, background } = previewAvatar
  const charColor = CHARACTER_COLORS[character] || '#FF8C42'

  const charName = (character || 'explorer').charAt(0).toUpperCase() + (character || 'explorer').slice(1)

  const charSrc = skin
    ? `/assets/avatar/clothes/${skin}/${skin}-${charName}.png`
    : `/assets/avatar/characters/${charName}.png`

  const bgSrc = background
    ? `/assets/avatar/backgrounds/${background}.svg`
    : '/assets/avatar/backgrounds/background-default.svg'

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <p style={{ margin: 0, fontSize: 15, fontWeight: 800, color: '#0D2A4F', textAlign: 'center' }}>My Avatar</p>

      {/* 미리보기 영역 */}
      <div style={{
        borderRadius: 28,
        overflow: 'hidden',
        position: 'relative',
        minHeight: 320,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#E8F0FE',
        boxShadow: 'inset 0 2px 12px rgba(79,107,237,.1)',
      }}>
        <img
          src={bgSrc}
          alt=""
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
          onError={(e) => { e.currentTarget.style.display = 'none' }}
        />

        <div style={{ position: 'relative', width: 220, height: 275, zIndex: 2 }}>
          <ImgLayer src={charSrc} fallbackColor={charColor} fallbackEmoji="/assets/icons/category-character.png" />
          {hat && <ImgLayer src={`/assets/avatar/hats/${hat}.png`} />}
          {handItem && <ImgLayer src={`/assets/avatar/hand-items/${handItem}.png`} />}
        </div>
      </div>

      {/* 버튼 */}
      <div style={{ display: 'flex', gap: 10 }}>
        <ActionButton onClick={onReset} title="Reset" emoji="/assets/icons/reset.png" />
        <ActionButton
          onClick={onSave}
          title={saving ? 'Saving…' : 'Save'}
          emoji="/assets/icons/save.png"
          primary
          disabled={saving}
        />
      </div>
    </div>
  )
}

const ActionButton = ({ onClick, emoji, title, primary, disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    title={title}
    style={{
      flex: primary ? 2 : 1,
      padding: '12px 0',
      border: primary ? 'none' : '2px solid #E0E8FF',
      borderRadius: 16,
      background: disabled && !primary ? '#F0F3F8' : primary ? 'linear-gradient(135deg,#6C8CFF,#4F6BED)' : '#fff',
      color: disabled && !primary ? '#B0BBC8' : primary ? '#fff' : '#4F6BED',
      fontSize: primary ? 14 : 16,
      fontWeight: 800,
      cursor: disabled ? 'not-allowed' : 'pointer',
      boxShadow: primary && !disabled ? '0 6px 18px rgba(79,107,237,.3)' : 'none',
      transition: 'all .2s',
      opacity: disabled ? 0.6 : 1,
    }}
    onMouseEnter={e => { if (!disabled) e.currentTarget.style.transform = 'translateY(-2px)' }}
    onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)' }}
  >
    <img src={emoji} alt="" style={{ width: 16, height: 16, objectFit: 'contain', verticalAlign: 'middle', marginRight: 6 }} />{title}
  </button>
)

export default AvatarPreview
